const ImageGallery = (() => {

    const initBlock = (el) => {
        const galleryItems = el.querySelector('[data-gallery-items]');
        const hasThumbs = galleryItems.children.length > 1;

        const license = el.dataset.license;

        const galleryPrev = el.querySelector('[data-gallery-left]');
        const galleryNext = el.querySelector('[data-gallery-right]');
        
        let prevButton, nextButton;

        let resizeTimer;
        
        const IsSlider = galleryItems.children.length > 1;
        
        const hasControls = el.hasAttribute("data-controls") ? el.hasAttribute("data-controls") : false;

        const getThumbMargin = () => window.innerWidth > 768 ? 16 : 8;
        const getThumbWidth = () => {
            const breakpoints = [
                { width: 1440, thumbSize: 160 },
                { width: 1200, thumbSize: 170 },
                { width: 1024, thumbSize: 144 },
                { width: 768, thumbSize: 104 }
            ];

            const found = breakpoints.find(bp => window.innerWidth > bp.width);
            return found ? found.thumbSize : 80;
        };
        
        const popupGallery = lightGallery(el.querySelector("[data-popup-gallery-items]"), {
            licenseKey: '4628D369-F2EC4BF8-98F3F83B-F7312AC5',
            selector: 'a',
            thumbnail: true,
            exThumbImage: 'data-thumb',
            zoom: true,
            fullScreen: true,
            download: false,
            counter: true,
            plugins: [lgThumbnail],
        });
        
        if(license) {

            const lg = lightGallery(galleryItems, {
                container: galleryItems,
                closable: false,
                showMaximizeIcon: false,
                fullScreen: false,
                zoom: false,
                download: false,
                toggleThumb: true,
                actualSize: false,
                counter: false,
                appendSubHtmlTo: '.lg-item',
                hideBarsDelay: 0,
                mode: 'lg-slide',
                thumbMargin: getThumbMargin(),
                controls: hasControls,
                loop: false,
                prevButton: galleryPrev,
                nextButton: galleryNext,
                currentPagerPosition: 'right',
                thumbWidth: getThumbWidth(),
                zoomFromOrigin: false,
                thumbnail: true,
                exThumbImage: 'data-thumb',
                licenseKey: license,
                plugins: [lgThumbnail]
            });
            lg.openGallery(0);

            const bindVisibleRenderedImages = () => {
                const visibleImages = el.querySelectorAll('.lg-item.lg-current img');

                visibleImages.forEach((img, index) => {
                    if (!img.dataset.overlayBound) {
                        img.style.cursor = 'pointer';
                        img.addEventListener('click', () => {
                            popupGallery.openGallery(index);
                            // Wait briefly and access the container
                            setTimeout(() => {
                                        const popupContainer = popupGallery.$container.firstElement;
                                  if (popupContainer) {
                                          popupContainer.classList.add('image-gallery-popup');
                                      } else {
                                          console.warn('❌ Could not find popup container');
                                      } 
                            }, 100);
                        });
                        img.dataset.overlayBound = "true";
                    }
                });
            };


            galleryItems.addEventListener("lgAfterOpen", (event) => {
                const { index } = event.detail ? event.detail : 0;
                bindVisibleRenderedImages(el, index);
            });

            IsSlider && galleryItems.addEventListener("lgAfterSlide", (event) => {
                const { index } = event.detail;                
                bindVisibleRenderedImages(el, index);
            });


            const updateButtonStates = (index) => {
                const totalItems = lg.galleryItems.length;
                galleryPrev.disabled = index === 0;
                galleryNext.disabled = index === totalItems - 1;
                if (prevButton) {
                    prevButton.disabled = index === 0;
                }
                if (nextButton) {
                    nextButton.disabled = index === totalItems - 1;
                }
            };

            const checkThumbnails = () => {
                const thumbsWrapper = el.querySelector(".lg-thumb.lg-group");
                if (!thumbsWrapper) {
                    console.error("Thumbnail wrapper not found");
                    return;
                }

                let childrenWidth = 0;
                Array.from(thumbsWrapper.children).forEach(child => {
                    const childWidth = child.offsetWidth;
                    childrenWidth += childWidth + getThumbMargin();
                    child.addEventListener("focus", ()=> {
                        child.click()
                    });
                });
                if (childrenWidth < thumbsWrapper.offsetWidth) {
                    galleryPrev.style.display = "none";
                    galleryNext.style.display = "none";
                } else {
                    galleryPrev.style.display = "";
                    galleryNext.style.display = "";
                    if (galleryPrev.classList.contains("opacity-0") && galleryNext.classList.contains("opacity-0")) {
                        setTimeout(() => {
                            galleryPrev.classList.remove("opacity-0");
                            galleryNext.classList.remove("opacity-0");
                        }, 500)
                    }

                }
            };

            const setAltText = () => {
                const lightboxImages = el.querySelectorAll(".lg-item img");
                const thumbnailImages = el.querySelectorAll(".lg-thumb-item img");
                const galleryLinks = galleryItems.querySelectorAll("a");

                galleryLinks.forEach((link, index) => {
                    const altText = link.getAttribute("data-alt") || "Gallery Image";
                    if (lightboxImages[index]) {
                        lightboxImages[index].alt = altText;
                    }
                    if (thumbnailImages[index]) {
                        thumbnailImages[index].alt = altText;
                    }
                });
            };

            const setDialogAttribute = () => {
                const dialog = el.querySelector(".lg-container");
                dialog.setAttribute("aria-label", "Image Gallery Wrapper");
            }
            
            const showControls = () => {
                galleryPrev.classList.remove("hidden");
                galleryNext.classList.remove("hidden");
            }
            
            const bindThumbFocus = () => {
                galleryItems.childNodes.forEach((item, i) => {
                    let index = i > 0 ? i * 0.5 : i;
                    const targetThumbnail = el.querySelector(`.lg-thumb [data-lg-item-id="${index}"]`);
                    item.addEventListener("focus", () => {
                        targetThumbnail && targetThumbnail.click();
                    });
                })
            }

            hasThumbs && galleryPrev.addEventListener('click', () => lg.goToPrevSlide());
            hasThumbs && galleryNext.addEventListener('click', () => lg.goToNextSlide());

            IsSlider && galleryItems.addEventListener("lgAfterSlide", (event) => {
                const {index} = event.detail;
                updateButtonStates(index);
            });
            galleryItems.addEventListener('lgAfterOpen', () => {
                prevButton = el.querySelector('.lg-prev');
                nextButton = el.querySelector('.lg-next');
                updateButtonStates(0);
                checkThumbnails();
                setAltText();
                setDialogAttribute();
                showControls();
                hasThumbs && bindThumbFocus();
            })

            if (!hasThumbs && IsSlider) {
                el.closest(".gallery-block").classList.add("gallery-block--hide-thumbs");
            }

            window.addEventListener("resize", () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    checkThumbnails();
                }, 300);
            });
        }
    };

    return {initBlock};
})();


document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('[data-image-gallery]').forEach(item => ImageGallery.initBlock(item));
});